import { styled, Typography } from "@mui/material";

export const LabelText = styled(Typography)`
  width: 100%;
  flex: 11 1 0;
`;

export const ValueText = styled(Typography)`
  width: 100%;
  flex: 9 1 0;
  display: flex;
  align-items: center;
  font-weight: 700;
  text-transform: capitalize;
  & svg {
    vertical-align: middle;
  }
`;
